// extracted by mini-css-extract-plugin
export default {"container":"index_container__LYglD","avatarContainer":"index_avatarContainer__YZgt-","avatarSvg":"index_avatarSvg__8pIrq","loadingText":"index_loadingText__evRUF"};